import type { AspectRatio } from "./aspectRatios";

// Retired pilot key, retained for historical-fixture cleanup/tests only.
// Availability is now standard; authorization comes from owning-set/brand access.
export const ITERATION_SIZE_DOWNLOAD_FLAG = "creative_iterations_multi_size_download";
export const MAX_SIZE_DOWNLOAD_ENTRIES = 32;
export type SizeDownloadItem = { resultId: string; adId: string; name: string; currentRatio: AspectRatio };
export type SizeDownloadExclusion = { name: string; reason: string };
export type SizeDownloadManifest = { items: SizeDownloadItem[]; excluded: SizeDownloadExclusion[] };
export type SizeOperationStatus = "pending" | "running" | "done" | "failed" | "uncertain";
export type SizeOperationView = {
  token: string;
  status: SizeOperationStatus;
  message?: string;
  elapsedMs?: number;
};

export function sizeDownloadExclusion(
  result: { status: string; generatedAdId?: string | null; imageUrl?: string | null; videoUrl?: string | null; mediaType?: string | null },
): string | null {
  if (result.mediaType && result.mediaType !== "image" || result.videoUrl) return "Not a static image";
  if (result.status !== "rendered" || !result.imageUrl) return "Image is not ready";
  if (!result.generatedAdId) return "No generated-ad ID (original source or legacy/incomplete result)";
  return null;
}

export function sizeDownloadName(name: string): string {
  // ASCII-only names are safe in ZIP paths and Content-Disposition headers.
  const cleaned = name.normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 _.-]/g, "-").replace(/\.{2,}/g, "-")
    .replace(/^[ .-]+|[ .-]+$/g, "").slice(0, 120);
  return cleaned || "Untitled-ad";
}

export function sizeDownloadFilename(name: string, ratio: AspectRatio, batch: boolean): string {
  const safe = sizeDownloadName(name);
  return batch ? `${ratio.replace(":", "x")}/${safe}.png` : `${safe}-${ratio.replace(":", "x")}.png`;
}

export function plannedSizeRequests(items: SizeDownloadItem[], ratios: readonly AspectRatio[]) {
  return items.flatMap(item => ratios.filter(ratio => ratio !== item.currentRatio).map(ratio => ({ item, ratio })));
}
